
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"11.47","height":"11.474"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_27932","data-name":"Group 27932","transform":"translate(-1687.997 -103.862)"}},[_c('g',{attrs:{"id":"Group_27728","data-name":"Group 27728","transform":"translate(1688 104)"}},[_c('g',{attrs:{"id":"Group_27730","data-name":"Group 27730"}},[_c('path',{attrs:{"id":"Path_20600","data-name":"Path 20600","d":"M9.752 1.191a1.508 1.508 0 00-2.133 0L1.636 7.17a.348.348 0 00-.084.148l-.79 2.841a.334.334 0 00.238.413.33.33 0 00.179 0l2.839-.787a.331.331 0 00.143-.085l5.979-5.978a1.511 1.511 0 000-2.134zM4.662 9.2L2.137 6.669m7.431-2.332L7 1.765","fill":"none","stroke":"#6b7786","stroke-width":"1.5"}})])])])])
          )
        }
      }
    